@import '~style-sheet-helpers/core.less';

.cancel-order-modal {
  width: 600px;
}

.modal-body {
  padding: 15px;
}

.modal-body-text {
  font-size: 13px;
  line-height: 18px;
}

.modal-footer {
  button {
    margin-left: 10px;
  }
}
